const timeSlices = () => {
	return document.getElementById('timeSlicesInputField').value;
}
export default timeSlices;
